/**
 * WordPress dependencies
 */
import { Button } from '@safe-wordpress/components';
import { _x, sprintf } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { v4 as uuid } from 'uuid';
import { usePageAttribute, usePluginSetting } from '@nab/data';

/**
 * Internal dependencies
 */
import './style.scss';
import { AiGenerateTestModal } from './ai-generate-test-modal';
import { AiIcon } from '../../ai-icon';

export const AiGenerateTestButton = (): JSX.Element | null => {
	const aiSettings = usePluginSetting( 'aiSettings' );
	const [ state, setState ] = usePageAttribute(
		'ai/testGenerationState',
		false
	);

	if ( ! aiSettings || 'admin-required' === aiSettings.type ) {
		return null;
	}

	const start = () =>
		false === state && setState( { id: uuid(), type: 'intro' } );

	return (
		<>
			<Button
				className="page-title-action nab-ai-generate-test-title-action"
				onClick={ start }
			>
				<AiIcon gap="6px" />
				{ sprintf(
					/* translators: %s: Nelio AI. */
					_x( 'Generate with %s', 'command', 'nelio-ab-testing' ),
					'Nelio AI'
				) }
			</Button>
			<AiGenerateTestModal aiSettings={ aiSettings } />
		</>
	);
};
